import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Структура пагинации в запросе */
let PitRequestCriteriaPage = class PitRequestCriteriaPage {
    get pageIndex() {
        return this._pageIndex;
    }
    set pageIndex(value) {
        this._pageIndex = value;
    }
    get pageSize() {
        return this._pageSize;
    }
    set pageSize(value) {
        this._pageSize = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "pageIndex", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitRequestCriteriaPage.prototype, "_pageIndex", void 0);
tslib_1.__decorate([
    jsonMember({ name: "pageSize", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitRequestCriteriaPage.prototype, "_pageSize", void 0);
PitRequestCriteriaPage = tslib_1.__decorate([
    jsonObject
], PitRequestCriteriaPage);
export { PitRequestCriteriaPage };
